import { PageTitleConstructor } from '@/study-search/models/page-title';
import { SearchPageSwitchRequestedEvent, SearchType } from '@studyportals/search-page-interface';
import { SearchPageReadyToLoadSearch } from '@/search-page-interface/src/events/SearchPageReadyToLoadSearch';
import { ISwitchTab,  } from '@studyportals/search-page-interface';
import { computed, Ref, ref } from 'vue';
import { PortalType } from '@studyportals/domain-client';
import store from '@/study-search/store';

export class NavigationBar {
	public readonly switchTabs: Ref<ISwitchTab[]> = ref([
		{
			label: "Programmes",
			type: SearchType.STUDY,
			visible: true,
			loading: false
		},
		{
			label: "Universities",
			type: SearchType.ORGANISATION,
			visible: true,
			loading: false
		},
		{
			label: "Scholarships",
			type: SearchType.SCHOLARSHIP,
			visible: this.shouldDisplayScholarshipsTab(),
			loading: false
		}
	]);
	public readonly searchTypeStudy = SearchType.STUDY;
	private readonly pageTitleConstructor = new PageTitleConstructor();
	public expanded: Ref<boolean> = ref(false);

	public staticContentEmpty = computed(() => {
		const staticContent = store.getters.getFaqStaticContent();

		return !staticContent || !staticContent.staticContentText;
	});

	public staticContent = computed(() => store.getters.getFaqStaticContent());

	public toggleExpand():void {
		this.expanded.value = !this.expanded.value;	
	}

	public visibleSwitchTabs = computed((): ISwitchTab[] => {
		return this.switchTabs.value.filter((tab: ISwitchTab) => tab.visible);
	});

	public title = computed((): string => {
		return this.pageTitleConstructor.getPageTitle();
	});

	public switchToTab(type: SearchType): void {

		this.setLoadingStateOnTab(type);

		if (window.EventAggregationService === undefined) {
			return;
		}

		if (type === SearchType.ORGANISATION) {
			window.EventAggregationService.publishTo(SearchPageReadyToLoadSearch.EventType, new SearchPageReadyToLoadSearch(SearchType.ORGANISATION, true));
			window.EventAggregationService.publishTo(SearchPageReadyToLoadSearch.EventType, new SearchPageReadyToLoadSearch(SearchType.SCHOLARSHIP, false));
		}

		if (type === SearchType.SCHOLARSHIP) {
			window.EventAggregationService.publishTo(SearchPageReadyToLoadSearch.EventType, new SearchPageReadyToLoadSearch(SearchType.SCHOLARSHIP, true));
			window.EventAggregationService.publishTo(SearchPageReadyToLoadSearch.EventType, new SearchPageReadyToLoadSearch(SearchType.ORGANISATION, false));
		}

		window.EventAggregationService.publishTo(SearchPageSwitchRequestedEvent.EventType, new SearchPageSwitchRequestedEvent(type));
	}

	private shouldDisplayScholarshipsTab(): boolean {
		return window.PortalType === PortalType.MASTER
			|| window.PortalType === PortalType.BACHELOR
			|| window.PortalType === PortalType.PHD;
	}

	private setLoadingStateOnTab(type: SearchType): void {
		if (type === SearchType.STUDY) return;

		this.switchTabs.value = this.switchTabs.value.map(tab => {
			if (tab.type === type) {
				return { ...tab, loading: true };
			}
			return tab;
		});
	}
}
